import { useCallback } from 'react';

import TrialUpgradeLink from '../../trialUser/TrialUpgradeLink';
import { useToast } from './useToast';

export function useTrialUserBlurToast() {
  const toast = useToast();
  // Stable identity — feeds the table's columnDef memo.
  return useCallback(() => {
    if (toast.isActive('td-trial-toast')) return;
    toast({
      id: 'td-trial-toast',
      title: 'Upgrade Required',
      description: (
        <span>
          Masked data is not available to trial users.{' '}
          <TrialUpgradeLink
            toastIdClose="td-trial-toast"
            linkText="Upgrade your trial"
          />{' '}
          to view.
        </span>
      ),
      status: 'warning',
      duration: null,
      isClosable: true,
      position: 'top-right',
      variant: 'subtle',
    });
  }, [toast]);
}
